import { ref, readonly } from "@nuxtjs/composition-api";
import { useApi } from "@wemade-vsf/composables";
import { Logger } from "@wemade-vsf/core";
import loadFaqMetaGql from "./loadFaqMeta.gql";
import loadFaqListGql from "./loadFaqList.gql";
function useFaq() {
  const loading = ref(false);
  const error = ref({
    loadFaqMeta: null,
    loadFaqList: null
  });
  const { query } = useApi();
  const loadFaqMeta = async () => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    Logger.debug(`useFaq/loadFaqMeta`);
    let meta = null;
    try {
      loading.value = true;
      const { data } = await query(loadFaqMetaGql);
      error.value.loadFaqMeta = null;
      meta = {
        meta_description: ((_c = (_b = (_a = data == null ? void 0 : data.MpMageplazaFaqsGetConfig) == null ? void 0 : _a.faq_home_page) == null ? void 0 : _b.seo) == null ? void 0 : _c.meta_description) || null,
        meta_title: ((_f = (_e = (_d = data == null ? void 0 : data.MpMageplazaFaqsGetConfig) == null ? void 0 : _d.faq_home_page) == null ? void 0 : _e.seo) == null ? void 0 : _f.meta_title) || null,
        title: ((_h = (_g = data == null ? void 0 : data.MpMageplazaFaqsGetConfig) == null ? void 0 : _g.faq_home_page) == null ? void 0 : _h.title) || null
      };
    } catch (err) {
      error.value.loadFaqMeta = err;
      Logger.error(`useFaq/loadFaqMeta`, err);
    } finally {
      loading.value = false;
    }
    return meta;
  };
  const loadFaqList = async (params = {}) => {
    var _a;
    Logger.debug(`useFaq/loadFaqList`);
    let categories = null;
    try {
      loading.value = true;
      const { data } = await query(loadFaqListGql, params);
      error.value.loadFaqList = null;
      categories = ((_a = data == null ? void 0 : data.MpMageplazaFaqsCategoryList) == null ? void 0 : _a.items) || null;
    } catch (err) {
      error.value.loadFaqList = err;
      Logger.error(`useFaq/loadFaqList`, err);
    } finally {
      loading.value = false;
    }
    return categories;
  };
  return {
    loading: readonly(loading),
    error: readonly(error),
    loadFaqMeta,
    loadFaqList
  };
}
export * from "./useFaq";
export {
  useFaq
};
